/**
 *  缓存页面刷新hook mixin
 *
 *  @param  fromList       Array   需要刷新的来源路由列表 (从其中页面进入需要刷新)
 *  @param  refreshHandle  String  用于刷新的回调方法名, 会接收到路由参数from
 */
export default function (fromList = [], refreshHandle = '') {
    return {
        beforeRouteEnter(to, from, next) {
            // vue实例是否已创建
            const isCreated = !!to.matched[to.matched.length - 1].instances.default;
            const needRefresh = isCreated && fromList.includes(from.name);

            next((vm) => {
                // 刷新
                if (needRefresh && refreshHandle) vm[refreshHandle](from);
            });
        },
    };
}
